<template>
   <svg viewBox="0 0 8 13" name="togglearrow" aria-hidden="true" focusable="false">
      <path
         fill-rule="evenodd"
         clip-rule="evenodd"
         d="M0.860558 0.343711C1.05582 0.148449 1.3724 0.148449 1.56766 0.343711L7.41659 6.19263L1.56766 12.0416C1.3724 12.2368 1.05582 12.2368 0.860558 12.0416C0.665296 11.8463 0.665296 11.5297 0.860558 11.3344L6.00237 6.19263L0.860558 1.05082C0.665296 0.855556 0.665296 0.538974 0.860558 0.343711Z"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
